<div [ngClass]="requirements() ? 'flex flex-col items-end sm:flex-row lg:flex-col lg:items-stretch' : ''">
    <form class="relative w-full lg:w-unset" [ngClass]="requirements() ? 'sm:w-1/2' : ''">
        @if (previewImage()) {
            <div class="relative mx-auto flex max-w-[700px] justify-center">
                <button
                    class="absolute right-5 top-5 flex items-center gap-10 bg-accent px-6 py-2 text-14 text-white hover:bg-accent-cta-hover"
                    (click)="remove()"
                    type="button"
                >
                    <span>Bild entfernen</span>
                    <i class="icon-fontawesome-trash"></i>
                </button>
                <ui-m000-c010-image
                    class="block h-full"
                    [classList]="'h-full w-full object-contain '"
                    [image]="{
                        image: previewImage() || '',
                        desktop: { width: 734 },
                        tablet: { width: 734 },
                        mobile: { width: 734 },
                    }"
                    priority
                    alt="Hero Bild"
                    contain
                />
            </div>
        } @else {
            <div
                class="mx-auto flex h-[260px] max-w-[700px] items-center justify-center border p-24 text-center"
                [ngClass]="isRequired() && error() ? 'border-red' : 'border-grey-200'"
            >
                @if (showLoadingSpinner()) {
                    <ui-m000-c040-loading-spinner />
                } @else {
                    <p>Keine Vorschau verfügbar.</p>
                }
            </div>
            <div class="w-full text-center">
                <ng-content select="[errorMsg]" />
            </div>
        }
        <label
            class="absolute bottom-32 left-0 right-0 ml-auto mr-auto max-w-[180px] cursor-pointer bg-accent p-2 text-center text-white hover:bg-accent-cta-hover"
            (click)="fileInput.click()"
        >
            <span>+ Datei hochladen</span>
            @if (isRequired()) {
                <span>*</span>
            }
        </label>
        <input
            class="hidden"
            #fileInput
            [accept]="acceptTypes()"
            (change)="fileChangeHandler($event)"
            type="file"
            required
        />
    </form>

    @if (requirements(); as req) {
        <div class="p-16 pb-0 text-14 sm:w-1/2 lg:w-unset">
            <p>Beim Hochladen von Fotos bitte folgendes beachten:</p>
            <p>
                @if (req.types) {
                    <span>
                        Dateiformat:
                        @for (type of req.types; track type; let last = $last) {
                            {{ last ? type : type + ', ' }}
                        }
                    </span>
                    <br />
                }

                @if (req.aspectRatio && withAspectRatio()) {
                    <span>Bildformat: {{ req.aspectRatio }}</span>
                    <br />
                }
                @if (req.minWidth || req.minHeight || req.maxHeight || req.maxWidth) {
                    <span>
                        Bildmaße:
                        @if (req.minHeight && req.minWidth) {
                            mindestens {{ req.minWidth }} Pixel x {{ req.minHeight }} Pixel;
                        } @else {
                            @if (req.minWidth) {
                                mindestens {{ req.minWidth }} Pixel Breite:
                            }
                            @if (req.minHeight) {
                                mindestens {{ req.minHeight }} Pixel Höhe;
                            }
                        }

                        @if (req.maxWidth && req.maxHeight) {
                            maximal {{ req.maxWidth }} Pixel x {{ req.maxHeight }} Pixel
                        } @else {
                            @if (req.maxWidth) {
                                maximal {{ req.maxWidth }} Pixel Breite
                            }
                            @if (req.maxHeight) {
                                maximal {{ req.maxHeight }} Pixel Höhe
                            }
                        }
                    </span>
                    <br />
                }
                @if (req.maxFileSize) {
                    <span>Dateigröße: max {{ req.maxFileSize | bytes }}</span>
                    <br />
                }
            </p>
        </div>
    }
</div>
